export const globalStyles = {
  colors: {
    bg: {
      primary: { value: '#0A0A0F' },
      secondary: { value: '#12121A' },
      tertiary: { value: '#1A1A25' },
      surface: { value: '#22222E' }
    },
    accent: {
      50: { value: '#E6F0FF' },
      100: { value: '#B3D4FF' },
      200: { value: '#80B8FF' },
      300: { value: '#4D9CFF' },
      400: { value: '#1A80FF' },
      500: { value: '#0070F3' },
      600: { value: '#005AC2' },
      700: { value: '#004492' },
      800: { value: '#002E61' },
      900: { value: '#001831' }
    },
    text: {
      primary: { value: '#F0F0F5' },
      secondary: { value: '#9090A0' },
      tertiary: { value: '#606070' }
    },
    positive: { value: '#00C48C' },
    negative: { value: '#FF4757' },
    warning: { value: '#FFB020' },
    border: {
      subtle: { value: 'rgba(255,255,255,0.06)' },
      DEFAULT: { value: 'rgba(255,255,255,0.10)' },
      strong: { value: 'rgba(255,255,255,0.16)' }
    },
    // Keep some legacy tokens for components that still reference them
    brand: {
      300: { value: '#4D9CFF' },
      400: { value: '#1A80FF' },
      500: { value: '#0070F3' },
      600: { value: '#005AC2' },
      700: { value: '#004492' }
    },
    black: {
      200: { value: '#2E2E2E' },
      300: { value: '#454545' },
      400: { value: '#212121' },
      500: { value: '#F0F0F5' },
      600: { value: '#FFFFFF' },
      700: { value: '#2B3674' }
    },
    gray: {
      50: { value: '#22222E' },
      100: { value: '#1A1A25' },
      200: { value: 'rgba(255,255,255,0.10)' },
      300: { value: '#1A1A25' },
      400: { value: '#22222E' },
      500: { value: '#9090A0' },
      600: { value: '#9090A0' },
      700: { value: '#606070' },
      900: { value: '#0A0A0F' }
    },
    secondaryGray: {
      100: { value: '#606070' },
      200: { value: '#12121A' },
      300: { value: '#0A0A0F' },
      400: { value: '#606070' },
      500: { value: '#22222E' },
      600: { value: '#606070' },
      700: { value: '#606070' }
    },
    red: {
      100: { value: '#2A1215' },
      200: { value: '#331518' },
      400: { value: '#FF4757' },
      500: { value: '#FF4757' },
      600: { value: '#FF4757' },
      700: { value: '#FF4757' }
    },
    danger: {
      500: { value: '#FF4757' }
    },
    green: {
      300: { value: '#0A2615' },
      600: { value: '#00C48C' },
      700: { value: '#00A876' }
    },
    blue: {
      500: { value: '#0070F3' },
      600: { value: '#005AC2' }
    },
    orange: {
      600: { value: '#FFB020' }
    },
    disabled: { value: '#606070' },
    borderLight: { value: 'rgba(255,255,255,0.06)' },
    borderSecondary: { value: 'rgba(255,255,255,0.10)' },
    secondaryBlack: { value: '#F0F0F5' },
    secondaryLightGray: { value: 'rgba(255,255,255,0.06)' },
    secondaryDarkGray: {
      100: { value: '#606070' },
      300: { value: '#606070' },
      400: { value: '#9090A0' },
      500: { value: '#9090A0' },
      600: { value: '#9090A0' },
      700: { value: '#606070' },
      900: { value: '#F0F0F5' }
    },
    lightGray: {
      200: { value: '#1A1A25' },
      400: { value: '#12121A' }
    },
    ultraLightGray: {
      500: { value: '#12121A' }
    }
  },
  styles: {
    global: () => ({
      body: {
        overflowX: 'hidden',
        bg: 'bg.primary',
        color: 'text.primary',
        fontFamily: 'Inter, sans-serif',
        fontWeight: 400,
        letterSpacing: '-0.02em'
      },
      input: {
        color: 'text.primary'
      },
      html: {
        fontFamily: 'Inter, sans-serif'
      },
      h1: {
        fontSize: '3xl',
        letterSpacing: '-0.04em'
      },
      h2: {
        fontSize: '2xl',
        letterSpacing: '-0.03em'
      },
      h3: {
        fontSize: 'xl',
        letterSpacing: '-0.02em'
      },
      h4: {
        fontSize: 'lg'
      },
      h5: {
        fontSize: 'md'
      },
      h6: {
        fontSize: 'md'
      }
    })
  }
}
